import { render } from "./PartialTitle.vue?vue&type=template&id=5547de56"
import script from "./PartialTitle.vue?vue&type=script&lang=js"
export * from "./PartialTitle.vue?vue&type=script&lang=js"

import "./PartialTitle.vue?vue&type=style&index=0&id=5547de56&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__